<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-container>
        <v-row>
          <v-col md="12">
            <v-alert
              v-if="teachers.length"
              type="warning"
            >
              <ul>
                <li v-for="teacher in teachers" :key="teacher.id">
                  {{ teacher.fulltext }}
                </li>
              </ul>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12">
            <v-btn
              class="mr-2"
              @click="save" color="primary">{{ $t('SAVE') }}
            </v-btn>
            <v-btn
              class="mr-2"
              v-if="teacher.id" @click="editSchool" color="primary">{{ $t('EDIT_SCHOOL') }}
            </v-btn>
            <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
          </v-col>
        </v-row>
        <v-row
          class="mb-6 mt-2"
          no-gutters
        >
        <v-col md="4">
          <ValidationProvider
            rules="required"
            vid="surname"
            :name="$t('fields.surname').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            ref="surnameField"
            v-model=" form.surname"
            :counter="30"
            :label="$t('fields.surname')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="email"
            vid="email"
            :name="$t('fields.email').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.email"
            :label="$t('fields.email')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="email"
            vid="alternative_email"
            :name="$t('fields.alternative_email').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
          v-model=" form.alternative_email"
          :label="$t('fields.alternative_email')"
          :error-messages="errors"
        ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            vid="phone"
            :name="$t('fields.phone').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.phone"
            :counter="30"
            :label="$t('fields.phone')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <v-text-field
          v-model=" form.alternative_phone"
          :counter="30"
          :label="$t('fields.alternative_phone')"
          :error-messages="errors"
        ></v-text-field>

        <ValidationProvider
            rules="required"
            vid="subject"
            :name="$t('fields.subject').toLowerCase()"
            v-slot="{ errors }"
        >
         <v-select
            :items="subjects"
            v-model="form.subject"
            item-text="name"
            item-value="id"
            :label="$t('fields.subject')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
        </v-col>
        <v-spacer></v-spacer>
        <v-col md="4">
        <ValidationProvider
            vid="region"
            :name="$t('fields.region').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="regions"
            v-model="form.region"
            @change="fetchProvinces()"
            item-text="name"
            item-value="id"
            attach
            :label="$t('fields.region')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            vid="province"
            :name="$t('fields.province').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="provinces"
            v-model="form.province"
            @change="fetchCities()"
            item-text="name"
            item-value="id"
            attach
            :label="$t('fields.province')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            vid="city"
            :name="$t('fields.city').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
            :items="cities"
            v-model="form.city"
            @change="fetchZipCodes()"
            item-text="name"
            item-value="id"
            attach
            :label="$t('fields.city')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            vid="address"
            :name="$t('fields.address').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.address"
            :counter="30"
            :label="$t('fields.address')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            vid="zipcode"
            :name="$t('fields.zipcode').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
            :items="zipcodes"
            v-model="form.zipcode"
            item-text="postalcode"
            item-value="id"
            attach
            :label="$t('fields.zipcode')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            vid="zone"
            :name="$t('fields.zone').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
            :items="zones"
            v-model="form.zone"
            item-text="name"
            item-value="id"
            attach
            :label="$t('fields.zone')"
            :error-messages="errors"
          >
        </v-select>
        </ValidationProvider>
        <v-switch
          v-model="form.privacy"
          flat
          :label="this.getPrivacyLabel"
        ></v-switch>
        </v-col>
        <v-spacer></v-spacer>
        <v-col md="3">
            <v-text-field
              v-model=" form.bookshop"
              :counter="30"
              :label="$t('fields.bookshop')"
              :error-messages="errors"
            ></v-text-field>


            <v-expansion-panels
              v-model="panel"
              multiple
            >

              <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('fields.notice_visible') }}
                <v-icon v-if="form.notice_visible">star</v-icon>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="form.notice_visible"
                  :label="$t('fields.notice_visible')"
                  :hint="$t('fields.notice_visible')"
              >
              </v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                  {{ $t('fields.notice_invisible') }}
                  <v-icon v-if="form.notice_invisible">star</v-icon>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                    v-model="form.notice_invisible"
                    :label="$t('fields.notice_invisible')"
                    :hint="$t('fields.notice_invisible')"
                >
                </v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>

            </v-expansion-panels>
        </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <TeacherContactOptions
              :prop-value="form.properties"
              @propertySelected="setProperty"
              :key="forceReload"
            />
          </v-col>
        </v-row>
        </v-container>
    </ValidationObserver>
    </v-card-text>

  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { teachersService } from '../../../utils/services/teachers.service';
  import { citiesService } from '../../../utils/services/cities.service';
  import { zonesService } from '../../../utils/services/zones.service';
  import { subjectsService } from '../../../utils/services/subjects.service';

  import TeacherContactOptions from '../../app/Teachers/TeacherContactOptions.vue';

  export default {
    name: 'TeacherModal',
    components: {
      TeacherContactOptions,
    },
    data() {
      return {
        panel: null,
        stored: null,
        teacher: {},
        regions: [],
        provinces: [],
        cities: [],
        zipcodes: [],
        zones: [],
        subjects: [],
        teachers: [],
        form: {
          name: '',
          surname: '',
          phone: '',
          email: '',
          address: '',
          region: '',
          province: '',
          city: '',
          zipcode: '',
          subject: '',
          zone: '',
          notice_visible: '',
          notice_invisible: '',
          privacy: true,
          alternative_email: '',
          alternative_phone: '',
          bookshop: '',
          properties: {},
        },
        forceReload: 0,
        loading: false,
        returnUrl: '',
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      getPrivacyLabel() {
        return `${this.$t('fields.privacy') } (${ this.$t(`fields.${this.form.privacy}`) })`;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),

      editSchool() {
        this.hideModal();
        this.$router.push({ path: `/teachers/${this.teacher.id}/show?tab=school&returnUrl=${this.returnUrl}` });
      },

      setProperty(properties) {
        this.form.properties = properties;
      },

      focusSurname() {
        this.$nextTick(() => {
          setTimeout(() => {
            const field = this.$refs.surnameField;
            if (field && field.focus) {
              field.focus();
            }
          }, 250);
        });
      },

      async checkTeacherExist() {
        await this.fetchTeachers();
        if (!this.teachers.length) {
          return true;
        }

        return confirm('Esiste un utente con i dati che hai già inserito.Vuoi procedere ?');
      },

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.teachers = [];
          const status = await this.checkTeacherExist();
          if (status) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
          }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchTeacher(id) {
        return teachersService.get(id)
        .then(response => {
            this.teacher = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchRegions() {
        return citiesService.getRegions({
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.regions = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchProvinces() {
        return citiesService.getProvinces(this.form.region, {
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.provinces = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchCities() {
        return citiesService.getCities(this.form.region, this.form.province, {
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.cities = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchZipCodes() {
        return citiesService.getZipCodes(this.form.region, this.form.province, this.form.city)
        .then(response => {
            this.zipcodes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchZones() {
        return zonesService.index()
        .then(response => {
            this.zones = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchSubjects() {
        return subjectsService.index({
          pagination: 0,
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.subjects = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchTeachers() {
        const filters = {
            search: `${this.form.surname } ${ this.form.name}`,
            subjectId: this.form.subject,
            sortBy: ['name'],
            sortDesc: [true],
        };

        if (this.data.stored.id) {
          filters.notInIds = [this.data.stored.id];
        }

        return teachersService.index({
          pagination: 0,
          filters,
        })
        .then(response => {
            this.teachers = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      await this.fetchRegions();
      if (this.data.stored.return_url) {
        this.returnUrl = this.data.stored.return_url;
      }

      if (this.data.stored.id) {
        await this.fetchTeacher(this.data.stored.id);
        const address = this.teacher.addresses.filter(
          element => element.options && element.options.is_default,
        );

        const defaultPropertyData = {
          facebook: false,
          whatsapp: false,
          instagram: false,
          telegram: false,
          meet: false,
          webinair: '',
          ado: '',
          other: '',
          platform: [],
        };

        this.form = {
          id: this.data.stored.id,
          name: this.teacher.name,
          surname: this.teacher.surname,
          address: (address.length) ? address[0].street : '',
          phone: (address.length) ? address[0].phone : '',
          email: (address.length) ? address[0].email : '',
          region: (address.length) ? address[0].region_id : '',
          province: (address.length) ? address[0].province_id : '',
          city: (address.length) ? address[0].city_id : '',
          zipcode: (address.length) ? address[0].postal_code_id : '',
          zone: (address.length) ? address[0].zone_id : '',
          subject: this.teacher.default_subject_id,
          notice_visible: this.teacher.options.notice_visible,
          notice_invisible: this.teacher.options.notice_invisible,
          privacy: this.teacher.options.privacy,
          alternative_email: this.teacher.options.alternative_email,
          alternative_phone: this.teacher.options.alternative_phone,
          bookshop: this.teacher.options.bookshop,
          properties: { ...defaultPropertyData, ...this.teacher.options.properties },
        };
        this.forceReload += 1;

        if (parseInt(this.form.region, 10)) {
          await this.fetchProvinces();
        }

        if (parseInt(this.form.region, 10) && parseInt(this.form.province, 10)) {
          await this.fetchCities();
        }
        if (
            parseInt(this.form.region, 10)
            && parseInt(this.form.province, 10)
            && parseInt(this.form.city, 10)
            ) {
              await this.fetchZipCodes();
          }
      }
      await this.fetchSubjects();
      await this.fetchZones();
      this.loadingModal(false);
      this.focusSurname();
    },

  };
</script>
